import React from "react";
import { styles } from "../../../src/styles/request_details";
import Loader from "components/Loader";

interface RejectModalProps {
    isOpen: boolean;
    rejectionReason: string;
    isProcessing: boolean;
    onReasonChange: (value: string) => void;
    onSubmit: () => void;
    onClose: () => void;
}

const RejectModal: React.FC<RejectModalProps> = ({
    isOpen,
    rejectionReason,
    isProcessing,
    onReasonChange,
    onSubmit,
    onClose,
}) => {
    if (!isOpen) return null;

    return (
        <div
            style={styles.modalOverlay}
            onClick={!isProcessing ? onClose : undefined}
        >
            <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                <h2 style={styles.modalHeader}>Reject Request</h2>

                <label style={styles.modalLabel}>
                    Reason for Rejection <span style={{ color: "#DC2626" }}>*</span>
                </label>
                <textarea
                    style={styles.modalTextarea}
                    placeholder="Please provide a reason for rejecting this request..."
                    value={rejectionReason}
                    onChange={(e) => onReasonChange(e.target.value)}
                    disabled={isProcessing}
                />

                <div style={styles.modalButtonGroup}>
                    <button
                        className="primary-button"
                        onClick={onClose}
                        disabled={isProcessing}
                        style={{
                            ...(isProcessing ? styles.buttonDisabled : {}),
                        }}
                    >
                        Cancel
                    </button>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span
                            style={{
                                display: "inline-flex",
                                width: 20,
                                height: 20,
                                alignItems: "center",
                                justifyContent: "center",
                                visibility: isProcessing ? "visible" : "hidden",
                            }}
                            aria-hidden={!isProcessing}
                        >
                            {isProcessing && <Loader height={20} width={20} custom={true} />}
                        </span>
                        <button
                            className="primary-button"
                            onClick={onSubmit}
                            disabled={isProcessing || !rejectionReason.trim()}
                            aria-label={isProcessing ? "Rejecting request" : "Reject request"}
                            aria-busy={isProcessing || undefined}
                            style={{
                                ...(!rejectionReason.trim() ? styles.buttonDisabled : {}),
                                opacity: isProcessing ? 0.5 : 1,
                                cursor: isProcessing || !rejectionReason.trim() ? "not-allowed" : "pointer",
                            }}
                        >
                            {isProcessing ? "Rejectting..." : "Reject"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RejectModal;